export enum PAGES {
  DOCTORS = 'doctors',
  PATIENTS = 'patients',
  TESTIMONIALS = 'testimonials',
  PRESS = 'press',
  HELP = 'help',
}

export enum PAGES_LEGAL {
  HOME = 'legal',
  PRIVACY_POLICY = 'privacy-policy',
}
